import type { BugSeverity } from '../../types';
import type { StatusChipColor } from '../../theme';

export interface BugSeverityMeta {
  label: string;
  color: StatusChipColor;
}

/** Nhãn + màu tiếng Việt cho từng độ nghiêm trọng của bug. */
export const BUG_SEVERITY_META: Record<BugSeverity, BugSeverityMeta> = {
  CRITICAL: { label: 'Nghiêm trọng', color: 'error' },
  MAJOR: { label: 'Cao', color: 'warning' },
  NORMAL: { label: 'Trung bình', color: 'info' },
  MINOR: { label: 'Thấp', color: 'default' },
};

export const BUG_SEVERITY_OPTIONS: BugSeverity[] = ['CRITICAL', 'MAJOR', 'NORMAL', 'MINOR'];
